export const whitelistParams = ['currency', 'lang', 'dayful', 'headlessExternalUrls'];
export function addWhiteListParamsToUrl(url, originalLocation) {
  const originalUrl = new URL(originalLocation);
  const params = whitelistParams.map(param => ({
    param,
    value: originalUrl.searchParams.get(param)
  })).filter(_ref => {
    let {
      value
    } = _ref;
    return !!value;
  });
  params.forEach(_ref2 => {
    let {
      param,
      value
    } = _ref2;
    url.searchParams.set(param, value);
  });
  return url;
}
//# sourceMappingURL=whiteListParams.js.map